import React from "react";
import PropTypes from "prop-types";
import BatteryFull from "@material-ui/icons/BatteryFull";
import Battery90 from "@material-ui/icons/Battery90";
import Battery80 from "@material-ui/icons/Battery80";
import Battery60 from "@material-ui/icons/Battery60";
import Battery50 from "@material-ui/icons/Battery50";
import Battery30 from "@material-ui/icons/Battery30";
import Battery20 from "@material-ui/icons/Battery20";
import BatteryAlert from "@material-ui/icons/BatteryAlert";

const BatteryIconContainer = ({ percent, style }) => {
  switch (true) {
    case percent >= 95:
      return (
        <div data-testid="batteryFull">
          <BatteryFull style={style} />
        </div>
      );
    case percent >= 90:
      return (
        <div data-testid="battery90">
          <Battery90 style={style} />
        </div>
      );
    case percent >= 80:
      return (
        <div data-testid="battery80">
          <Battery80 style={style} />
        </div>
      );
    case percent >= 60:
      return (
        <div data-testid="battery60">
          <Battery60 style={style} />
        </div>
      );
    case percent >= 50:
      return (
        <div data-testid="battery50">
          <Battery50 style={style} />
        </div>
      );
    case percent >= 30:
      return (
        <div data-testid="battery30">
          <Battery30 style={style} />
        </div>
      );
    case percent >= 20:
      return (
        <div data-testid="battery20">
          <Battery20 style={style} />
        </div>
      );
    default:
      return (
        <div data-testid="batteryEmpty">
          <BatteryAlert style={style} />
        </div>
      );
  }
};

BatteryIconContainer.propTypes = {
  percent: PropTypes.number.isRequired,
  style: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

BatteryIconContainer.defaultProps = {
  style: {
    height: 100,
    width: 100,
  },
};

export default BatteryIconContainer;
